/* eslint-disable */

import { fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { getDocumentLang } from "./helpers";
import { logout } from "../app/store/reducers/authSlice";

export const staggeredBaseQueryWithBailOut = (baseUrl) =>
  retry(
    async (args, api, extraOptions) => {
      const result = await fetchBaseQuery({ baseUrl, prepareHeaders })(
        args,
        api,
        extraOptions
      );
      if (result.error?.status === 401) {
        const token = localStorage.getItem("token");

        if (token) {
          localStorage.removeItem("token");
          localStorage.removeItem("is_admin");
          api.dispatch(logout());
        }

        retry.fail(result.error);
      }
      // Bail out immediately on any client error (4xx) or server error (500).
      // Client errors will never succeed on retry; 500s are handled separately.x
      const status = result.error?.status;
      if (typeof status === "number" && (status >= 400 || status === 500)) {
        retry.fail(result.error);
      }
      return result;
    },
    {
      maxRetries: 1,
    }
  );

const prepareHeaders = async (headers, { getState }) => {
  const token = localStorage.getItem("token");
  const country = localStorage.getItem("country");
  
  token ? headers.set("Authorization", token) : null;
  headers.set("Accept-Language", getDocumentLang());
  if (country) {
    headers.set("X-Country-Code", country);
  }
  return headers;
};

export function calculateDurationInHoursAndMin(durationsInSeconds) {
  const hours = Math.floor(durationsInSeconds / 3600);
  const minutes = Math.round((durationsInSeconds % 3600) / 60);
  return {
    hours,
    minutes,
  };
}

export function calculateRemaingDays(endDate) {
  const oneDay = 24 * 60 * 60 * 1000;
  const currentDate = new Date();

  return Math.round((endDate - currentDate) / oneDay);
}

export function stripHtml(htmlString) {
  if (!htmlString) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  return doc.body.textContent || "";
}
